"use client";

import { ADMIN_ROUTES, ForgotPasswordForm as SharedForgotPasswordForm } from "@pulseprep/shared-ui";
import { useAdminForgotPassword } from "@pulseprep/shared-ui/hooks";

export function ForgotPasswordForm() {
  const { forgotPassword, isLoading } = useAdminForgotPassword();

  return (
    <SharedForgotPasswordForm
      forgotPasswordFn={forgotPassword}
      isLoading={isLoading}
      loginHref={ADMIN_ROUTES.login}
    />
  );
}
